import { Nullable } from 'types';

export const isConfirmed = (status: Nullable<string>) => {
  if (!status) return false;
  return status?.toLowerCase().includes('confirmed');
};

export const isRejected = (status: Nullable<string>) => {
  if (!status) return false;
  return status?.toLowerCase().includes('reject');
};

export const isCreated = (status: Nullable<string>) => {
  if (!status) return false;
  return status?.toLowerCase().includes('created');
};

export const isProposed = (status: Nullable<string>) => {
  if (!status) return false;
  return status?.toLowerCase().includes('proposed');
};

export const isFinalized = (status: Nullable<string>) => {
  if (!status) return false;
  return status?.toLowerCase().includes('finalized');
};

export const isCanceled = (status: Nullable<string>) => {
  if (!status) return false;
  return status?.toLowerCase().includes('canceled');
};
